import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterEdge extends Bloc {
	constructor (src, ctx) {
		super("filteredge", src, ctx);
		this.f = (src, ins) => [card => ins[0] ? card.fromEdge : card.isEdgeActive()];
		this.types = [Types.bool];
	}
}
